import { AnyAction } from 'redux';
import produce from 'immer';
import {
  GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST,
  GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS,
  GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE,
  GET_SCHEDULE_RESERVATION_CONFIRM_INITIAL,
} from '../../actions';

// 予約情報
export type ReservationDetail = {
  eqsId: number; // 設備シフトID
  eqsName: string | null; // 設備シフト名
  annexFlag: number; // 別館フラグ
  remaining: number; // 残り数
  nickName: string | null; // ニックネーム
  spaceName: string | null; // スペースネーム
  bookFlag: number; // 予約中フラグ
};

type ReservationConfirm = {
  result: number;
  errorMessage: string | null;
  contentsName: string | null; // コンテンツ名
  annexFlag: number; // 別館フラグ
  contentsComment: string | null; // コンテンツスコメント
  cancelTime: string | null; // キャンペーン可能時間
  companionUpperLimit: number; // 同行者人数上限
  equipmentLayoutPicture: string | null; // 設備配置図
  equipmentLayoutName: string | null; // 設備配置図名
  contentsClassification: number; // コンテンツ分類 0：設備、1：シフト
  scheduleReservationList: ReservationDetail[];
  clubAddress: string | null; // クラブアドレス
};

export type ReservationConfirmData = {
  isGetReservationConfirmLoading: boolean;
  isGetReservationConfirmLoaded: boolean;
  reservationConfirmData: ReservationConfirm;
};

const initialState: ReservationConfirmData = {
  isGetReservationConfirmLoading: false,
  isGetReservationConfirmLoaded: false,
  reservationConfirmData: {
    result: 0,
    errorMessage: null,
    contentsName: '',
    annexFlag: 0,
    contentsComment: '',
    cancelTime: '',
    companionUpperLimit: 0,
    equipmentLayoutPicture: '',
    equipmentLayoutName: '',
    contentsClassification: 0,
    scheduleReservationList: [],
    clubAddress: '',
  },
};

const reservationConfirmReducer = (state = initialState, action: AnyAction): ReservationConfirmData => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST:
        dataState.isGetReservationConfirmLoading = true;
        dataState.isGetReservationConfirmLoaded = false;
        dataState.reservationConfirmData = initialState.reservationConfirmData;
        break;
      case GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS:
        dataState.isGetReservationConfirmLoading = false;
        dataState.isGetReservationConfirmLoaded = true;
        dataState.reservationConfirmData = action.data;
        break;
      case GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE:
        dataState.isGetReservationConfirmLoading = false;
        dataState.isGetReservationConfirmLoaded = false;
        dataState.reservationConfirmData = initialState.reservationConfirmData;
        break;
      case GET_SCHEDULE_RESERVATION_CONFIRM_INITIAL:
        dataState.isGetReservationConfirmLoading = false;
        dataState.isGetReservationConfirmLoaded = false;
        dataState.reservationConfirmData = initialState.reservationConfirmData;
        break;
      default:
        break;
    }
  });
};

export default reservationConfirmReducer;
